export const UserInfoLoading = () => {
  return (
    <div className="animate-pulse flex items-center mr-11 ml-16">
      <div className="flex space-x-4">
        <div className="rounded-full bg-slate-200 h-8 w-8" />
      </div>
    </div>
  );
};
